<template>
  <div class="product-card">
    <buy-one-get-one
      v-if="item.BuyAGetB_promotion"
      v-bind:fromQty="item.BuyAGetB_FromQty"
      v-bind:relatedQty="item.BuyAGetB_RelatedQty"
    >
    </buy-one-get-one>
    <div class="ref_div product_box" @click="goToProductDetail(item)">
      <div class="top_tx_lf">
        <div class="refNo_sp pro_tt" v-if="this.refNum && this.refNum != ''">{{this.refNum}}</div>
        <div class="refNo_sp pro_tt" v-if="this.refNum == ''"><p class="hideTx">1</p></div>
        <div class="refNo_rg_sp pro_t_one" v-if="$route.path =='/collections' || $route.path =='/home'">{{item.LotNum}}</div>
      </div>
      <!-- <div class="ref_print_div top_tx_lf_print">
        <div class="pro_tt_left_print" v-if="this.refNum && this.refNum != ''">{{this.refNum}}</div>
        <div class="pro_tt_left_print" v-if="this.refNum == ''"><p class="hideTx_print">1</p></div>
        <div class="pro_tt_right_print" v-if="$route.path =='/collections'">{{item.LotNum}}</div>
      </div> -->
      <div class="ProImg">
        <img v-if="favoritesPage" src="../assets/img/times.svg" class="pc-fav" @click="deFavoriteProduct(item)" style="cursor: pointer"/>
        <a style="width:100%; height:100%; display: flex;flex-direction: column; justify-content: center; align-items: center;">
          <img
            v-if="this.img"
            :src="this.img"
            alt=""
            class="img"
          />
          <img
            v-else
            :src="require('../assets/img/defaultImg.png')"
            alt=""
            class="img"
          />
        </a>
      </div>
      <div class="Pro-Details">
        <div class="price-bot">
          <p class="title_lt_p ProTitle" v-if="$i18n.locale=='en' && $route.path !='/collections'"><a :href="this.link">{{this.name}}</a></p>
          <p class="title_lt_p ProTitle" v-else-if="$i18n.locale === 'ch' && $route.path !='/collections'"><a :href="this.link">{{this.description}}</a></p>
          <p class="title_rg_p ProTitle_r" v-if="$i18n.locale=='en'&& $route.path =='/collections'"><a :href="this.link">{{this.name}}</a></p>
          <p class="title_rg_p ProTitle_r" v-else-if="$i18n.locale === 'ch'&& $route.path =='/collections'"><a :href="this.link">{{this.description}}</a></p>
          <div class="packageSize">
              {{this.packageSize}}
            </div>
          <!-- <div class="price-marge" v-if="loggedIn && showPrice">
            <div class="price_original" v-show="isPromotion">
              <span>${{item.OriginalPrice ? item.OriginalPrice.toFixed(2) : ''}}</span>
            </div>
          </div> -->
          <div class="price-marge" >
            <div class="pro_row">
              <div class='stock_row_dv pro_cl_lf'>
                <span class='pro_tt stock_sp' v-if="loggedIn && showInstock && !this.isOutOfStock(item)">{{$t('stock')}}: </span>
                <span class='pro_tt stock_sp' v-if="loggedIn && showInstock && !this.isOutOfStock(item)">{{item.InventoryQuantity ? item.InventoryQuantity : 0}}</span>
                <span class='pro_tt_red stock_sp_red' v-if="loggedIn && showInstock && this.isOutOfStock(item)">{{$t('outOfStock')}}</span>
              </div>
              <div class="price_row_dv pro_cl_rg">
                <span class="price_hide_show price_hide" v-show="item && item.Price || false" v-if="loggedIn && showPrice">{{$t('price')}}:</span>
                <span class='price_sp pro_tt' v-show="item && item.Price || false" v-if="loggedIn && showPrice">${{item ? item.Price.toFixed(2) : ''}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="price-marge_print" >
            <div class="pro_row_print">
              <div class="pro_cl_lf_print">
                <span v-if="loggedIn && showInstock && !this.isOutOfStock(item)" class="pro_t_print">{{$t('stock')}}: </span>
                <span v-if="loggedIn && showInstock && !this.isOutOfStock(item)" class="pro_t_print">{{item.InventoryQuantity ? item.InventoryQuantity : 0}}</span>
              <span v-if="loggedIn && showInstock && this.isOutOfStock(item)" class="pro_tt_red_print">{{$t('outOfStock')}}</span>
              </div>
              <div class="pro_cl_rg_print">
                <span v-show="item && item.Price || false" v-if="loggedIn && showPrice" class="pro_t_print">{{$t('price')}}:</span>
                <span v-show="item && item.Price || false" v-if="loggedIn && showPrice" class="pro_t_print">${{item ? item.Price.toFixed(2) : ''}}</span>
              </div>
            </div>
          </div> -->
          <div class="price-marge">
            <div :class="['price__regular', (this.isPromotion || item.BuyAGetB_promotion) ? 'promo' : '']">
            </div>
            <div class="price_original" v-show="isPromotion">
            </div>
          </div>
          <barcode v-if="barcode" :value="barcode" :options="barcode_option"></barcode>
        </div>
      </div>
    </div>
    <div class="images-modal-mask" v-if="imagesVisible" @click.self="closeImages">
      <div class="images">
        <img :src="images" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { flyToElement } from "../store/modules/cart.js";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
import star0 from '../assets/img/star0.jpg'
import star1 from '../assets/img/star1.jpg'
import star2 from '../assets/img/star2.jpg'
import busUtil from "../assets/js/util";
import buyOneGetOne from "../components/buy-one-get-one/buy-one-get-one";
import barcode from "@xkeshi/vue-barcode";

export default {
  name: 'productCard',
  components: {
    'buy-one-get-one': buyOneGetOne,
    barcode
  },
  props: [
    'img',
    'link',
    'name',
    'description',
    'brand',
    'isPromotion',
    'price',
    'item',
    'quantity',
    'favoritesPage',
    'rating',
    'refNum',
    'productNum',
    'barcode',
    'packageSize',
    'isZoom',
  ],
  data() {
    return {
      list: [],
      found: false,
      num: 0,
      localCount: 0,
      barcode_option: {
        displayValue: true, //是否默认显示条形码数据
        background: 'rgba(0,0,0,0)', //条形码背景颜色
        width: '1.8rem',
        height: '22px',
        fontSize: '14px',
        lineColor: '#000',
      },
      imgIsLoadEnd: false,
      //商品图片的弹窗
      imagesVisible: false,
      images: ''
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId', 'removeProductFromFavorites']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('cart', ['updateProductCount']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.InventoryQuantity > 0 ? false : true
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/addCart', item);
        // this.found = true;
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/getCart');
      }
    },
    getItemQuantity: function() {
      if (isUserAuthenticated()) {
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
            this.found = true;
          }
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    incrementAddToCart: function(item, add, e) {
      if (add) {
        let quantity = this.num + 1;
        if (isUserAuthenticated()) {
          flyToElement(event.target, $('.cart-link'));
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.getItemQuantity();
          })
        } else {
          this.$store.dispatch('cart/addProductToLocalCart', item);
        }
      } else if (!add) {
        let quantity = this.num - 1;
        if (quantity < 1) {
          this.deleteItem(item)
        } else {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
          } else {
            item.quantity = quantity;
            this.$store.dispatch('cart/updateLocalCart', item)
            .then(() => {
              this.$store.dispatch('cart/fetchCartProducts')
            });
          }
        }
      }
    },
    throttleAddToCart:  _.debounce(function(item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        }
      });
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
    checkInsideCart() {
      if (isUserAuthenticated()) {
        if (!this.cartProductsList.Sales_Order_Lines.length) {
          this.found = false;
          this.num = 0;
          return;
        }
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            return;
          }
        }
      } else {
        //For whatever reason this portion is necessary for removing the found variable when
        //itemCount is below 1.
        if (!this.cartProductsList.length) {
          this.found = false;
          this.num = 0;
          return;
        } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            }
          }
        }
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount])
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
    onClickBrand() {
      if (this.brand) {
        if (this.$router.currentRoute.path !== '/collections') {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewSearch(this.brand, 'Brand');
          }, 600);
        } else {
          this.$root.selectNewSearch(this.brand, 'Brand');
        }
      }
    },
    deFavoriteProduct(item) {
      this.removeProductFromFavorites(item.Product_id)
    },
    getStarIndex(rating) {
      let temp = [];
      if (rating || rating === 0) {
        for (let i=1; i<6; i++) {
          if (rating >= i) {
          temp.push(star2);
          } else if (rating > (i-1) && rating < i) {
          temp.push(star1);
          } else if (rating <= (i-1)) {
          temp.push(star0);
          }
        }
      } else {
        temp = [star0, star0, star0, star0, star0];
      }
      return temp;
    },
    imgLoad() {
      this.imgIsLoadEnd = true
      this.$emit('imgLoad')
    },
    imgAbort() {
      this.imgIsLoadEnd = true
      this.$emit('imgAbort')
    },
    imgError() {
      this.imgIsLoadEnd = true
      this.$emit('imgError')
    },
    //点击商品图片
    clickZoom(images){
      if(images){
        //显示商品图片的弹窗
        this.imagesVisible=true;
        this.images=images;
      }
    },
    closeImages(){
      this.imagesVisible=false;
    }
  },
  mounted() {
    // Commenting out for now. Keeping in case AFM changes mind.
    // this.checkInsideCart();
    // this.getItemQuantity(this.item);
  },
  beforeUpdate() {
    // Commenting out for now. Keeping in case AFM changes mind.
    // this.checkInsideCart();
    // this.getItemQuantity(this.item);
  },
  computed: {
    ...mapState({
      cartProductsList: state => state.cart.cartProductsList,
      itemCount: state => state.cart.itemCount,
      itemDeletedLoading: state => state.cart.itemDeletedLoading,
      windowHeight: state => state.navbar.windowHeight,
      windowWidth: state => state.navbar.windowWidth,
      addToCartLoading: state => state.cart.addToCartLoading,
      loggedIn: state => state.auth.loggedIn,
      showPrice: state => state.auth.showLevel5Price,
      showInstock: state => state.auth.showInstock,
    }),
    imgIsLoad({imgIsLoadEnd, img}) {
      // 没有图片或者图片已经加载结束（无论终止、错误还是成功）
      return !img || imgIsLoadEnd
    }
  },
  watch: {
        // Commenting out for now. Keeping in case AFM changes mind.
    // cartProductsList: function(newVal, oldVal) {
    //   if (newVal !== oldVal || newVal.length !== oldVal.length) {
    //     this.checkInsideCart();
    //     this.getItemQuantity(this.item);
    //   }
    // },
  }
}
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productCard.less";
.v-lazy-image {
  filter: blur(5px);
  transition: filter 1.6s;
  will-change: filter;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
.disabled {
  pointer-events:none;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/view/productCard.vue